import { gql } from '@apollo/client'

export const SET_SHIPPING_ADDRESSES_ON_CART = gql`
  mutation SetShippingAddressOnCart(
    $cartId: String!
    $shippingAddresses: [ShippingAddressInput]!
  ) {
    setShippingAddressesOnCart(
      input: { cart_id: $cartId, shipping_addresses: $shippingAddresses }
    ) {
      cart {
        items {
          id
        }
      }
    }
  }
`
